import { RootState } from 'handlers';

export const getLoanBreakdown = ({ loanBreakdown }: RootState) => loanBreakdown;
